import { CalendarDays, Clock, MapPin } from 'lucide-react'
import Link from 'next/link'
import { type TripSliderData } from '@/types/trip.type'
import { DEFAULT_IMAGE } from '@/lib/constant'
import { cloudFrontUrl, currencyHelper, dateFormater } from '@/lib/utils'
import TripEnquiryForm from '../forms/trip-enquiry-form'
import PrimaryButton from '../ui/primary-button'
import { ImageLoader } from '../ui/image-loader'
import { isAfter, isToday } from 'date-fns'


const TripCard = ({ data, isTrips = true }: { data: TripSliderData[0], isTrips?: boolean }) => {
    return (
        <div className='rounded-lg overflow-hidden h-full w-full bg-white max-w-96 mx-auto flex flex-col gap-0 group select-none border'>
            <Link href={`/${isTrips ? "trip" : "trek"}/${data.slug}`} className='relative h-52 w-full flex justify-end items-end'>
                <ImageLoader src={data.cover_image_url ? cloudFrontUrl(data.cover_image_url) : DEFAULT_IMAGE} alt='trek-karo-india trips' fill className='object-cover' />
                <div className='h-fit w-fit bg-white py-1.5 px-4 rounded-full absolute left-3 bottom-0 translate-y-1/2 shadow'>
                    <div className='flex flex-1 gap-1 justify-center items-center text-black text-xs tracking-wider'>
                        <Clock className='size-3.5 -mt-[1px]' /> {data.number_of_days}Days / {data.number_of_nights}Night
                    </div>
                </div>
                <span className='py-1 px-3 bg-white rounded-full absolute top-2 left-2 text-black font-normal text-xs font-lexend capitalize'>
                    {data.type}
                </span>
            </Link>
            <div className='flex flex-col gap-0 pb-4 px-4'>
                <Link href={`/${isTrips ? "trip" : "trek"}/${data.slug}`} className='flex flex-col gap-4 py-4'>
                    <h3 className='-mb-2 mt-2 font-lexend font-medium text-lg text-primary-text group-hover:text-custom-primary transition duration-500 text-ellipsis overflow-hidden text-nowrap'>
                        {data.title}
                    </h3>
                    <div className='grid grid-cols-2 relative'>
                        <span className='h-full w-0.5 scale-x-50 bg-[#777E90] absolute left-1/2 -translate-x-1/2' />
                        <div className='flex flex-col gap-1'>
                            <div className='text-sm flex flex-1 items-center gap-2 text-primary-text'>
                                <MapPin className='h-4 w-4' />
                                {data.location}
                            </div>
                            <div className='text-sm flex flex-1 items-center gap-2 pr-1.5'>
                                <CalendarDays className='text-primary-text h-4 w-4 shrink-0' />
                                <div className='space-x-1 text-nowrap overflow-hidden text-ellipsis'>
                                    {
                                        data.trip_batches
                                            .filter((date) => isAfter(date, new Date()) || isToday(date))
                                            .map((date, i) => (
                                                <span key={i}>{dateFormater({ date, formatString: "dd MMM" })},</span>
                                            ))
                                    }
                                </div>
                            </div>
                        </div>
                        <div className='h-full w-full flex flex-col justify-center items-start pl-5'>
                            <p className='text-[0.625rem] relative text-secondary-text'>
                                {
                                    data.sudo_price && <>
                                        Rs. {currencyHelper(data.sudo_price)}/<span className='text-[0.375rem] text-[#777E90]'>per</span>
                                        <span className='h-0.5 w-full scale-y-[0.33] bg-red-600 absolute top-1.5 left-0 -rotate-6' />
                                    </>
                                }

                            </p>
                            <p className='text-lg font-semibold'>
                                Rs. {currencyHelper(data.main_price)}<span className='text-[#777E90]'>/</span><span className='text-[0.625rem] text-[#777E90]'>per</span>
                            </p>
                        </div>
                    </div>
                </Link>
                <div className='flex gap-3 items-center w-full'>
                    <TripEnquiryForm destination={data.title} />
                    <PrimaryButton btnName='More Details' href={`/${isTrips ? "trip" : "trek"}/${data.slug}`} icon className='w-full shrink [&>div]:justify-center' />
                </div>
            </div>
        </div>
    )
}

export default TripCard